import shallow from 'zustand/shallow';
import { RouteExecutionStatus } from './types';
import { useRouteExecutionStore } from './useRouteExecutionStore';
export const useExecutingRoutesIds = (address) => {
    return useRouteExecutionStore((state) => Object.values(state.routes)
        .filter((item) => item.route.fromAddress === address &&
        (item.status === RouteExecutionStatus.Pending ||
            item.status === RouteExecutionStatus.Failed))
        .sort((a, b) => {
        var _a, _b, _c, _d;
        return ((_b = (_a = b === null || b === void 0 ? void 0 : b.route.steps[0].execution) === null || _a === void 0 ? void 0 : _a.process[0].startedAt) !== null && _b !== void 0 ? _b : 0) -
            ((_d = (_c = a === null || a === void 0 ? void 0 : a.route.steps[0].execution) === null || _c === void 0 ? void 0 : _c.process[0].startedAt) !== null && _d !== void 0 ? _d : 0);
    })
        .map(({ route }) => route.id), shallow);
};
